(function (Drupal, $) {
  Drupal.behaviors.news_detail = {
    attach: function (context) {
      $(function() {
        if ($('.page-node-type-news, .page-node-type-event').length) {
          if($('aside.layout-sidebar-second #block-ocg-custom-newsletter').length > 1) {
            $('aside.layout-sidebar-second #block-ocg-custom-newsletter').first().remove();
          }

          $(once('newsletter', 'aside.layout-sidebar-second #block-ocg-custom-newsletter', context)).first().hide().appendTo('.newsletter__wrapper').fadeIn(300);
          $('.newsletter__wrapper').fadeIn(300);
        }
      });
    }
  }
})(Drupal, jQuery);
